const WarningIcon = () => (
	<div style={{ width: 115, height: 115 }}>
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 133 133"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="warning-group" fill="none" stroke="none">
				<polygon
					id="triangle"
					fill="#f1c40f"
					points="66.5,20 120,110 13,110"
				/>
				<text
					id="exclamation"
					x="66.5"
					y="92"
					textAnchor="middle"
					fontSize="60"
					fontWeight="bold"
					fill="#000000"
				>
					!
				</text>
			</g>
		</svg>

		<style jsx>{`
			#warning-group {
				transform-origin: center;
				animation: pulse 0.4s ease-in-out 1.05s both;
			}

			#triangle {
				transform-origin: center;
				transform: scale(0);
				animation: triangle-scale 0.4s ease-in-out 0.4s forwards;
			}

			#exclamation {
				opacity: 0;
				transform: scale(0.8);
				animation: fade-in 0.3s ease-in-out 0.9s forwards;
			}

			@keyframes triangle-scale {
				from {
					transform: scale(0);
				}
				to {
					transform: scale(1);
				}
			}

			@keyframes fade-in {
				from {
					opacity: 0;
					transform: scale(0.8);
				}
				to {
					opacity: 1;
					transform: scale(1);
				}
			}

			@keyframes pulse {
				0% {
					transform: scale(1);
				}
				50% {
					transform: scale(1.08);
				}
				100% {
					transform: scale(1);
				}
			}
		`}</style>
	</div>
);

export default WarningIcon;